import React from 'react'
import Footer from '../../../../../UI/Modal/Footer/Footer'

const ModalFooter = ({ saveDisabled, saved, cancelled }) => {
  return <Footer save={saved} cancel={cancelled} disable={saveDisabled} />
}

export default ModalFooter
